<template>
    <BaseButton
        type="button"
        :class="['button-show-more', ...getBemModifiers()]"
        :name="text"
        @click.native="click"
    >
        <BaseText
            :aria-label="text"
            class="button-show-more__text"
            :text="text"
        />
    </BaseButton>
</template>

<script>
import BaseButton from '~/components/common/Button/BaseButton';
import BaseText from '~/components/common/Text/BaseText';

export default {
    name: 'ButtonShowMore',
    availableBemModifiers: ['grid-orders'],
    components: {
        BaseText,
        BaseButton,
    },
    props: {
        /**
         * text for button
         */
        text: {
            type: String,
            default: 'Pokaż więcej',
        },
    },
    methods: {
        click() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss">
    .button-show-more {
        $self: &;

        &.base-button {
            line-height: 1;
            overflow: hidden;
            padding: 4px 0;
            margin: 0 auto;
            width: auto;
        }

        &__text {
            font: $font-weight-bold 16px/18px $goodHomeFontFamily;
            color: $color-slate100;
            display: inline-block;
            padding-right: 22px;
            position: relative;

            &::after {
                @include colored-icon('arrow-down', $color-slate100, 13px 7px);
                content: '';
                display: block;
                right: 0;
                top: 6px;
                position: absolute;
            }
        }

        &--grid-orders {
            #{$self}__text {
                color: $color-slate70-dark;

                &::after {
                    @include colored-icon('arrow-down', $color-slate70);
                }
            }
        }
    }
</style>
